import { CampaignData, campaignsShow } from '@jobilla/nexus-sdk'
import { notFound, redirect } from '@tanstack/react-router'
import { AxiosError } from 'axios'
import { campaignIsArchived, notAuthorized } from '../errors'

type CampaignCheck = 'archived' | 'draft'

export const campaignGuard = async (
	params: {
		campaignId: string
		companyId: string
	},
	checks: CampaignCheck[] = ['archived', 'draft'],
): Promise<void> => {
	let campaign: CampaignData

	try {
		const response = await campaignsShow(params.campaignId)
		campaign = response.data
	} catch (error) {
		if (error instanceof AxiosError) {
			if (error.response?.status === 401 || error.response?.status === 403) {
				throw notAuthorized({
					type: 'campaign',
					data: { campaignId: params.campaignId },
				})
			}

			if (error.response?.status === 404) {
				throw notFound()
			}
		}

		throw error
	}

	if (checks.includes('draft') && campaign.status !== 'draft') {
		throw redirect({
			to: '/company/$companyId/$campaignId',
			params: {
				companyId: params.companyId,
				campaignId: params.campaignId,
			},
		})
	}

	if (checks.includes('archived') && campaign.isArchived) {
		throw campaignIsArchived({
			data: {
				campaignId: params.campaignId,
				companyId: params.companyId,
			},
		})
	}
}
